<div class="container">
  <div class="line"></div>
  <div class="thumb">
    <coin-anim-icon
      svgIcon="drag"
      class="chart-icon"
      [startFrame]="12"
      [speed]="1"
      [animation]="anim"
      [delay]="10"
      [loop]="true"
      (mouseenter)="mouseEnterLeave()"
      (mouseleave)="mouseEnterLeave()"></coin-anim-icon>
  </div>
  <div class="line"></div>
</div>
